import React, {useEffect} from 'react'
import {TextField, Grid} from '@material-ui/core';
import '../App.css';
import { useStyles } from '../Components/useStyles';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
  import DateFnsUtils from '@date-io/date-fns';
  import 'date-fns';

export default function StudentIDPage({studentID,applicantDOB, applicantLastName, applicantFirstName, studentRef}) {
        const classes = useStyles();
        const [errorState, setErrorState] = React.useState(false);
        const [errorFirstNameState, setErrorFirstNameState] = React.useState(false);
        const [errorLastNameState, setErrorLastNameState] = React.useState(false);
        const regexpName = /^$|^[-A-Za-z ]+$/;
      
        const [applicantDateOfBirth, setApplicantDOB] = React.useState(applicantDOB);
        const [applicantFName, setApplicantFirstName] = React.useState(applicantFirstName);
        const [applicantLName, setApplicantLastName] = React.useState(applicantLastName);
        const [applicantID, setPupulNo] = React.useState(studentID);
        let load = false;

        useEffect(() => {
            load = true;
            studentRef.current = {applicantID:studentID, applicantFName:applicantFirstName, applicantLName:applicantLastName, applicantDateOfBirth:applicantDOB};
         },[]);
    
         useEffect(() => {
            if(!load)
            studentRef.current = {applicantID, applicantFName, applicantLName, applicantDateOfBirth};
            else 
                load = false;
    
         },[applicantID, applicantFName, applicantLName, applicantDateOfBirth]);

        function handleBlur(number) {
          if (number === 0 || number === null) {
            setErrorState(true);
            setPupulNo(number);
          } else if (number !== studentID) {
            setPupulNo(number);
          }
        }
        function handleDateChange(date) {
          if (date !== null && !isNaN(date.getTime())) setApplicantDOB(date.toDateString());
          else if (date === null) setApplicantDOB(null);
        }
        function handleFirstNameBlur(firstname) {
          if (firstname === '') {
            setErrorFirstNameState(true);
          } else {
            setErrorFirstNameState(false);
          }
      
          setApplicantFirstName(firstname);
        }
        function handleLastNameBlur(lastname) {
          if (lastname === '') {
            setErrorLastNameState(true);
          } else {
            setErrorLastNameState(false);
          }
      
          setApplicantLastName(lastname);
        }
        
    return(
        <>  
            <h1 className='Title2-settings'>Please provide the student's 7-digit Pupil number.</h1>

            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField required id="txt_studentid" label="Pupil Number" defaultValue={studentID === 0 ? null: studentID} error={errorState} helperText={errorState ? 'Student\'s Pupil Number is empty' : ' '}
                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onChange={event=>setPupulNo(event.target.value)} inputProps={{maxLength: 7}}
                    /> 
                </Grid>
                <Grid item xs={6}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>           
                        <KeyboardDatePicker variant="inline" format="MM/dd/yyyy" margin="normal" id="date_studentDOB" label="Date of Birth"
                            value={applicantDOB} fullWidth={true} KeyboardButtonProps={{ 'aria-label': 'change date',}} maxDate={new Date()} maxDateMessage={"Student\'s birth date can not be in the future"}
                            className={classes.FulltextField} inputVariant="outlined" disableFuture={true} onChange={handleDateChange} emptyLabel="mm/dd/yyyy"
                    />
                    </MuiPickersUtilsProvider>              
                </Grid>

            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField required id="txt_studentFirstName" label="Student First Name" defaultValue={applicantFirstName} error={errorFirstNameState || !regexpName.test(applicantFirstName)} helperText={errorFirstNameState ? 'Student\’s first name is empty' : !regexpName.test(applicantFirstName) ? 'Student\'s first name must be in English characters.' : ''}
                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onChange={event=>setApplicantFirstName(event.target.value)}
                    /> 
                </Grid>
                <Grid item xs={6}>
                    <TextField required id="txt_studentLastName" label="Student Last Name" defaultValue={applicantLastName} error={errorLastNameState || !regexpName.test(applicantLastName)} helperText={errorLastNameState ? 'Student\’s last name is empty' : !regexpName.test(applicantLastName) ? 'Student\'s last name must be in English characters' : ''}
                        className={classes.FulltextField} margin="normal" variant="outlined" fullWidth={true} onChange={event=>setApplicantLastName(event.target.value)}
                    /> 
                </Grid>
            </Grid>
        </>
    );
}
